import * as React from 'react';
import { Provider } from 'mobx-react';
import { MyLinks } from './MyLinks';
import { MyLinksStore } from './stores';
import { IMyLink } from '../../interfaces/IMyLink';
import { IFontSlots } from '../../interfaces/IFontSlots';

export interface IProps {
  highlightColor: string;
  myLinks: IMyLink[];
  title?: string;
  marginTop?: number;
  displayType?: "Standard" | "Condensed" | "Tiles";
  linkTextColor?: string;
  linkIconColor?: string;
  linkBackgroundColor?: string;
  linkBorderRadius?: string;
  linkBorderColor?: string;
  linkBorderStyle?: string;
  defaultLinkIcon?: string;
  linkDropShadow?: boolean;
  collapseCommandBarItems?: boolean;
  hasDarkBackground?: boolean;
  fontSlots?: IFontSlots;
  onChange: (myLinks: IMyLink[]) => void;
}

export class IAMyLinks extends React.Component<IProps> {

  private myLinksStore: MyLinksStore;

  constructor(props: IProps) {
    super(props);
    this.myLinksStore = new MyLinksStore();
    this.myLinksStore.highlightColor = props.highlightColor;
    this.myLinksStore.myLinks = props.myLinks;
    this.myLinksStore.marginTop = props.marginTop;
    this.myLinksStore.title = props.title;
    this.myLinksStore.displayType = props.displayType ? props.displayType : "Standard";
    this.myLinksStore.linkTextColor = props.linkTextColor;
    this.myLinksStore.linkIconColor = props.linkIconColor;
    this.myLinksStore.linkBackgroundColor = props.linkBackgroundColor;
    this.myLinksStore.linkBorderRadius = props.linkBorderRadius;
    this.myLinksStore.linkDropShadow = props.linkDropShadow;
    this.myLinksStore.collapseCommandBarItems = props.collapseCommandBarItems;
    this.myLinksStore.linkBorderStyle = props.linkBorderStyle;
    this.myLinksStore.linkBorderColor = props.linkBorderColor;
    this.myLinksStore.defaultLinkIcon = props.defaultLinkIcon ? props.defaultLinkIcon : "Arrow";
    this.myLinksStore.hasDarkBackground = props.hasDarkBackground ? props.hasDarkBackground : false;
    this.myLinksStore.fontSlots = props.fontSlots;
  }

  public componentWillReceiveProps(props: IProps) {
    if (props != this.props) {
      this.myLinksStore.highlightColor = props.highlightColor;
      this.myLinksStore.myLinks = props.myLinks;
      this.myLinksStore.marginTop = props.marginTop;
      this.myLinksStore.title = props.title;
      this.myLinksStore.displayType = props.displayType ? props.displayType : "Standard";
      this.myLinksStore.linkTextColor = props.linkTextColor;
      this.myLinksStore.linkIconColor = props.linkIconColor
      this.myLinksStore.linkBackgroundColor = props.linkBackgroundColor;
      this.myLinksStore.linkBorderRadius = props.linkBorderRadius;
      this.myLinksStore.linkDropShadow = props.linkDropShadow;
      this.myLinksStore.collapseCommandBarItems = props.collapseCommandBarItems;
      this.myLinksStore.linkBorderStyle = props.linkBorderStyle;
      this.myLinksStore.linkBorderColor = props.linkBorderColor;
      this.myLinksStore.defaultLinkIcon = props.defaultLinkIcon ? props.defaultLinkIcon : "Arrow";
      this.myLinksStore.hasDarkBackground = props.hasDarkBackground ? props.hasDarkBackground : false;
      this.myLinksStore.fontSlots = props.fontSlots;
    }
  }

  render() {
    return (
      <Provider myLinksStore={this.myLinksStore}>
        <MyLinks 
          onChange={() => this.props.onChange(this.myLinksStore.myLinks)}
        />
      </Provider>
    )
  }
}